import React, { useState } from 'react';
import BuilderHeader from './BuilderHeader';
import CompetitionBar from './CompetitionBar';
import BuilderMobileNav from './BuilderMobileNav';
import SavedWidgetsList from './SavedWidgetsList';
import ConfigPanel from './ConfigPanel';
import PreviewPanel from './PreviewPanel';
import EmbedPanel from './EmbedPanel';
import { mobilePanelClass } from './builderPanelVisibility';

/**
 * Desktop (lg+): three columns — configure | preview | embed.
 * Mobile: one column at a time with bottom tabs.
 */
export default function BuilderLayout() {
  const [mobileTab, setMobileTab] = useState('configure');

  return (
    <div className="h-screen flex flex-col bg-slate-50 overflow-hidden">
      <BuilderHeader />
      <CompetitionBar />
      <div className="flex-1 flex flex-col lg:flex-row min-h-0 overflow-hidden">
        <aside
          className={`${mobilePanelClass(mobileTab, 'configure')} bg-white border-r border-slate-200`}
        >
          <SavedWidgetsList />
          <ConfigPanel />
        </aside>
        <PreviewPanel className={mobilePanelClass(mobileTab, 'preview')} />
        <EmbedPanel className={mobilePanelClass(mobileTab, 'embed')} />
      </div>
      <BuilderMobileNav activeTab={mobileTab} onChange={setMobileTab} />
    </div>
  );
}
